import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Role } from '../types';
import { Landmark, Shield } from 'lucide-react';
export const LoginPage: React.FC = () => {
  const [selectedRole, setSelectedRole] = useState<Role>('operator');
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    login(selectedRole);
    navigate('/');
  };
  return <div className="min-h-screen bg-slate-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-467">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-468">
        <div className="flex justify-center" data-id="element-469">
          <div className="h-16 w-16 bg-slate-900 rounded-full flex items-center justify-center shadow-lg" data-id="element-470">
            <Landmark className="text-teal-400" size={32} data-id="element-471" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-2xl font-bold text-slate-900" data-id="element-472">
          Survey Khatian Publishing
        </h2>
        <p className="mt-2 text-center text-sm text-slate-600" data-id="element-473">
          Department of Land Records and Surveys (DLRS)
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-474">
        <div className="bg-white py-8 px-4 shadow-xl sm:rounded-lg sm:px-10 border-t-4 border-teal-600" data-id="element-475">
          <div className="mb-6 flex items-center justify-center space-x-2 text-slate-500 bg-slate-50 py-2 rounded-md border border-slate-200" data-id="element-476">
            <Shield size={16} data-id="element-477" />
            <span className="text-xs font-semibold uppercase tracking-wider" data-id="element-478">
              Authorized Zone
            </span>
          </div>

          <form className="space-y-6" onSubmit={handleLogin} data-id="element-479">
            <div data-id="element-480">
              <label htmlFor="role" className="block text-sm font-medium text-slate-700" data-id="element-481">
                Select Role (Demo)
              </label>
              <div className="mt-1" data-id="element-482">
                <select id="role" name="role" className="input-field" value={selectedRole} onChange={e => setSelectedRole(e.target.value as Role)} data-id="element-483">
                  <option value="operator" data-id="element-484">Settlement Press Operator</option>
                  <option value="officer" data-id="element-485">Settlement Press Officer</option>
                  <option value="zso" data-id="element-486">Zonal Settlement Officer (ZSO)</option>
                  <option value="admin" data-id="element-487">DLRS Admin Officer</option>
                </select>
              </div>
            </div>

            <div data-id="element-488">
              <label htmlFor="username" className="block text-sm font-medium text-slate-700" data-id="element-489">
                Username
              </label>
              <div className="mt-1" data-id="element-490">
                <input id="username" name="username" type="text" disabled value={`demo_${selectedRole}`} className="input-field bg-slate-50 text-slate-500" data-id="element-491" />
              </div>
            </div>

            <div data-id="element-492">
              <label htmlFor="password" className="block text-sm font-medium text-slate-700" data-id="element-493">
                Password
              </label>
              <div className="mt-1" data-id="element-494">
                <input id="password" name="password" type="password" disabled value="********" className="input-field bg-slate-50 text-slate-500" data-id="element-495" />
              </div>
            </div>

            <div data-id="element-496">
              <button type="submit" className="w-full btn-primary flex justify-center py-2.5" data-id="element-497">
                Sign in to System
              </button>
            </div>
          </form>

          <div className="mt-6 text-center text-xs text-slate-400" data-id="element-498">
            Government of the People's Republic of Bangladesh
          </div>
        </div>
      </div>
    </div>;
};